import 'ui-core/plugins/polyfills/js/CustomEvent';

(function () {
    var quickSearchDetached = {
        // @TODO come up with a better name

        triggerSelector: '.js-search-detached__trigger',
        targetSelector: '.js-search-detached__panel',
        insertBeforeSelector: '.header--first-row',
        target: {},
        trigger: {},
        insertBefore: {},
        event: null,

        init: function () {
            this.target = document.querySelector(
                this.targetSelector
            ); /* consider data related approach i.e. acquiring selector from data of the tigger */
            this.trigger = document.querySelector(this.triggerSelector);
            this.insertBefore = document.querySelector(this.insertBeforeSelector);

            this.event = new CustomEvent('quickSearch:toggled');

            if (this.trigger !== null) {
                this.accordion(this.trigger, this.target);
                this.relocate();
            }
        },

        relocate: function () {
            this.insertBefore.parentElement.insertBefore(this.target, this.insertBefore);
        },

        accordion: function () {
            var self = this;
            self.trigger.addEventListener('click', function (e) {
                e.preventDefault();

                if (self.target.classList.contains('js--open')) {
                    self.target.style.overflow = 'hidden';
                    self.target.classList.remove('js--open');
                    self.trigger.classList.remove('js--active');
                } else {
                    self.target.classList.add('js--open');
                    self.target.querySelector('[name="AllField"]').focus();
                    self.trigger.classList.add('js--active');
                }
            });

            self.target.addEventListener('transitionend', function quickSearchDetachedAnimationCallback(e) {
                document.dispatchEvent(self.event);
                if (self.target.classList.contains('js--open')) {
                    e.target.style.overflow = 'visible';
                }
            });
        },
    };

    UX.quickSearchDetached = quickSearchDetached;
})();
